<div class="detail-view">
    <div>
        <ng-container *ngIf="course$ | async as course; else loader">
            <section class="background-color-nearwhite">
                <div class="course container" *ngIf="course">
                    <da-course-teaser [showBookingBtn]="true" [showDemoBtn]="true" [course]="course"></da-course-teaser>
                </div>
            </section>
            <section class="background-color-white container">
                <div class="content course-details">
                    <div class="left">
                        <da-tab-section [data]="course"></da-tab-section>
                    </div>
                </div>
                <a *ngIf="description && (showDownload$ | async) && site === 'de_de'" (click)="printPDFCourse()" class="download"
                    ><span class="drg-icon-download"></span><span class="download-label">Trainingsbeschreibung drucken oder als PDF herunterladen</span
                ></a></section
        ></ng-container>
    </div>
    <ng-container *ngIf="similarCourse$ | async as similarCourse">
        <ng-container *ngIf="showSimilarCourses$ | async">
            <da-similar-courses *ngIf="similarCourse && similarCourse.length > 0" [similarCourses]="similarCourse"></da-similar-courses>
        </ng-container>
    </ng-container>

    <ng-template #loader>
        <section>
            <div id="loader-screen" class="drg-loading-container">
                <i class="loading-icon"></i>
                <i class="loader-shadow"></i>
            </div>
        </section>
    </ng-template>

    <ng-template #warningWishlist>
        <div class="embedcontainer">
            <ng-container *ngTemplateOutlet="warnWishlist"></ng-container>
        </div>
    </ng-template>
    <ng-template #warnWishlist>
        <div class="modal">
            <div class="popup-warning">
                <div class="details">
                    <h3 [innerHTML]="'addToShopingCart.courseAlreadyInWishlistTitle' | translate"></h3>
                    <p [innerHTML]="'addToShopingCart.courseAlreadyInWishlistText' | translate"></p>
                    <div class="button-container">
                        <div class="button-wrapper">
                            <a class="button secondary" da-link (click)="closeModal()" [innerHTML]="'common.close' | translate"></a>
                            <a class="button primary" da-link (click)="goToCart()" [innerHTML]="'courses.showCart' | translate"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="notification" *ngIf="showCartUpdate$ | async as showCartUpdate">
        <div class="modal" *ngIf="course$ | async as course">
            <div class="location-popup" [ngClass]="showCartUpdate ? 'fade' : ''">
                <div class="title">
                    <span class="checked"></span>
                    <span [innerHTML]="'courses.update' | translate"></span>
                </div>
                <div class="inner-wrapper">
                    <div class="details">
                        <span>{{ course.name }}</span>
                        <span *ngIf="course.price !== undefined && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                            <span *ngIf="currencyPositionBefore$ | async" class="headline currency-before" [innerHTML]="currency"></span>
                            {{ course.price | currency: '':'':format:languageCode }}
                            <span *ngIf="!(currencyPositionBefore$ | async)" class="headline currency-after" [innerHTML]="currency"></span>
                            <span [innerHTML]="'booking.bookingParticipants.symbol' | translate"></span>
                        </span>

                        <div class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                            <span [innerHTML]="'courses.noPrice' | translate"></span>
                        </div>
                    </div>
                    <div class="type">{{ course.type }}</div>
                    <a (click)="goToCart()" class="button secondary" [innerHTML]="'courses.showCart' | translate"></a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="pdf-wrapper">
    <div #pdfCourse id="pdfCourse" *ngIf="course$ | async as course">
        <ng-container>
            <section>
                <div *ngIf="course">
                        <div class="logo-container one-column container-box">
                            <img [src]="logo"/>
                        </div>
                        <div class="two-column-right container-box learning-and-image">
                            <div class="leftcolumn">
                                <div class="title">
                                    <strong>{{ course.name }}</strong>
                                </div>
                                <p *ngIf="course.training.subTitle" class ="subtitle">{{course.training.subTitle}}</p>
                            </div>
                            <div class="rightcolumn">
                                <div class="media" *ngIf="courseImage$ | async as courseImage">
                                    <img [src]="courseImage" />
                                </div>
                            </div>
                        </div>
                        <div *ngIf="course.training.descriptionShort" class="grey-box short-description">
                            <p>{{course.training.descriptionShort}}</p>
                        </div>
                        <div class="two-column-right container-box">
                            <div class="leftcolumn">
                                <div class="short-infos">
                                    <div *ngIf="events && events.length > 0">
                                        <div class="subtitle-blue">Dauer</div>
                                        <p>{{ eventDuration}} <span *ngIf="eventDuration === 1">Tag</span><span *ngIf="eventDuration > 1">Tage</span>, {{course.events[0].beginDateTime | date: 'HH.mm'}} Uhr - {{course.events[0].endDateTime | date: 'HH.mm'}} Uhr</p>
                                    </div>
                                    <div>
                                        <div class="subtitle-blue">Teilnehmerzahl</div>
                                        <p>max. {{course.slotsMax}} Personen</p>
                                    </div>
                                    <div>
                                        <div class="subtitle-blue">Preis</div>
                                        <div class="price" *ngIf="course.prices.length > 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                                            <span *ngIf="currencyPositionBefore$ | async" class="headline currency-before" [innerHTML]="currency"></span>
                                            <span *ngIf="course.prices.length === 1 || course.prices.length > 1 && course.prices[1].value === course.prices[0].value"> {{ course.prices[0].value  | currency: '':'':format:languageCode }}</span>
                                            <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value > 0">{{ course.prices[0].value | currency: '':'':format:languageCode }} - {{ course.prices[1].value | currency: '':'':format:languageCode }}</span>
                                            <span *ngIf="course.prices.length > 1 && course.prices[1].value > course.prices[0].value && course.prices[0].value === 0">{{ course.prices[1].value | currency: '':'':format:languageCode }}</span>
                                            <span *ngIf="!(currencyPositionBefore$ | async)" class="headline currency-after" [innerHTML]="currency"></span><span> zzgl. gesetztl. MwST. pro Person</span>
                                            <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
                                        </div>
                                        <div class="price" *ngIf="course.price !== undefined && course.prices.length === 0 && ( course.metadata === null || !course.metadata || course.metadata.showPrice)">
                                            <span *ngIf="currencyPositionBefore$ | async" class="headline currency-before" [innerHTML]="currency"></span>
                                            <span> {{ course.price  | currency: '':'':format:languageCode }}</span>
                                            <span *ngIf="!(currencyPositionBefore$ | async)" class="headline currency-after" [innerHTML]="currency"></span><span> zzgl. gesetztl. MwST. pro Person</span>
                                            <span class="vat" *ngIf="showVat$ | async" [innerHTML]="'common.vatPrice' | translate"></span>
                                        </div>
                                        <div class="price" *ngIf="course.metadata && !course.metadata.showPrice">
                                            <span [innerHTML]="'courses.noPrice' | translate"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="rightcolumn">
                                <div class="qr-code-wrapper">
                                   <div class="qr-code-image">
                                      <qrcode [qrdata]="courseUrl" [width]="70"></qrcode>
                                    </div>
                                    <div class="label-box">
                                        <span class="label">Anmelden / Termin wählen</span>
                                        <span class="url">{{courseUrlPrint}}</span>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </section>
            <section class="more-details-box">
                <div *ngIf="targetGroupText">
                    <div class="subtitle-blue">Training geeignet für</div>
                    <div *ngFor="let paragraph of targetGroupText">
                        <p>{{paragraph.text}}</p>
                        <ul *ngIf="paragraph.subTexts !== null">
                            <li *ngFor="let subtext of paragraph.subTexts">{{subtext}}</li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="requirementsText">
                    <div class="subtitle-blue">Voraussetzung</div>
                    <div *ngFor="let paragraph of requirementsText">
                        <p>{{paragraph.text}}</p>
                        <ul *ngIf="paragraph.subTexts !== null">
                            <li *ngFor="let subtext of paragraph.subTexts">{{subtext}}</li>
                        </ul>
                    </div>
                </div>
                <div *ngIf="courseContentText && courseContentText[0].subTexts !== null">
                    <div class="subtitle-blue">Das erwartet Sie bei uns</div>
                    <div *ngIf="courseContentText[0] && courseContentText[0].subTexts.length <= 5">
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[0].subTexts; index as i">
                                <li>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                    <div class="two-column-center">
                        <div *ngIf="courseContentText[0] && courseContentText[0].subTexts.length > 5" class="leftcolumn" [ngClass]="{'border': courseContentText[0].subTexts.length > 5}">
                            <ul>
                                <li *ngFor="let subtext of courseContentText[0].subTexts | slice:0:5">{{subtext}}</li>
                            </ul>
                        </div>
                        <div class="rightcolumn">
                            <ul>
                                <li *ngFor="let subtext of courseContentText[0].subTexts | slice:5:10">{{subtext}}</li>
                            </ul>
                        </div>
                    </div>
                    <div *ngIf="courseContentText[0] && courseContentText[0].subTexts.length > 10">
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[0].subTexts; index as i">
                                <li *ngIf="i > 9">{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
                <div *ngIf="courseContentText" class="two-column-center more-content">
                    <div *ngIf="courseContentText.length > 1" class="leftcolumn">
                        <div class="subtitle-blue">{{courseContentText[1].text}}</div>
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[1].subTexts">
                                <li [ngClass]='{"bold" : subtext.indexOf(":") > -1 }'>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                    <div *ngIf="courseContentText.length > 2" class="rightcolumn">
                        <div class="subtitle-blue">{{courseContentText[2].text}}</div>
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[2].subTexts">
                                <li [ngClass]='{"bold" : subtext.slice(-1) === ":"}'>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
                <div *ngIf="courseContentText" class="two-column-center more-content">
                    <div *ngIf="courseContentText.length > 3" class="leftcolumn">
                        <div class="subtitle-blue">{{courseContentText[3].text}}</div>
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[3].subTexts">
                                <li [ngClass]='{"bold" : subtext.slice(-1) === ":"}'>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                    <div *ngIf="courseContentText.length > 4" class="rightcolumn">
                        <div class="subtitle-blue">{{courseContentText[4].text}}</div>
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[4].subTexts">
                                <li [ngClass]='{"bold" : subtext.slice(-1) === ":"}'>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
                <div *ngIf="courseContentText" class="two-column-center more-content">
                    <div *ngIf="courseContentText.length > 5" class="leftcolumn">
                        <div class="subtitle-blue">{{courseContentText[5].text}}</div>
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[5].subTexts">
                                <li [ngClass]='{"bold" : subtext.slice(-1) === ":"}'>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                    <div *ngIf="courseContentText.length > 6" class="rightcolumn">
                        <div class="subtitle-blue">{{courseContentText[6].text}}</div>
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[6].subTexts">
                                <li [ngClass]='{"bold" : subtext.slice(-1) === ":"}'>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
                <div *ngIf="courseContentText" class="two-column-center more-content">
                    <div *ngIf="courseContentText.length > 7" class="leftcolumn">
                        <div class="subtitle-blue">{{courseContentText[7].text}}</div>
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[7].subTexts">
                                <li [ngClass]='{"bold" : subtext.slice(-1) === ":"}'>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                    <div *ngIf="courseContentText.length > 8" class="rightcolumn">
                        <div class="subtitle-blue">{{courseContentText[8].text}}</div>
                        <ul>
                            <ng-container *ngFor="let subtext of courseContentText[8].subTexts">
                                <li [ngClass]='{"bold" : subtext.slice(-1) === ":"}'>{{subtext}}</li>
                            </ng-container>
                        </ul>
                    </div>
                </div>
            </section>
            <section class="note-section">
                <div *ngIf="noteText" class="grey-box">
                    <p class="headline-small">Gut zu wissen</p>
                    <div *ngFor="let paragraph of noteText">
                        <p>{{paragraph.text}}</p>
                        <ul *ngIf="paragraph.subTexts !== null">
                            <li *ngFor="let subtext of paragraph.subTexts">{{subtext}}</li>
                        </ul>
                    </div>
                </div>
            </section>
            <section *ngIf="events && events.length > 0" class="location-section">
                <div class="subtitle-blue location">Standorte</div>
                <div class="four-column container-box">
                    <div *ngIf="eventsNorth && eventsNorth.length > 0" class="column">
                        <div class="subtitle-blue">NORD</div>
                        <div *ngFor="let city of citiesNorth">
                            <div class="events-in-city">
                                <span>{{city}}</span>
                                <div *ngFor="let event of eventsNorth">
                                    <div *ngIf="event.location.city === city">
                                        <p *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: 'dd.MM.yy'}} - {{ event.endDateTime | date: 'dd.MM.yy'}}
                                        </p>
                                        <p *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: 'dd.MM.yy'}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    <div *ngIf="eventsEast && eventsEast.length > 0" class="column">
                        <div class="subtitle-blue">OST</div>
                        <div *ngFor="let city of citiesEast">
                            <div class="events-in-city">
                                <span>{{city}}</span>
                                <div *ngFor="let event of eventsEast">
                                    <div *ngIf="event.location.city === city">
                                        <p *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: 'dd.MM.yy'}} - {{ event.endDateTime | date: 'dd.MM.yy'}}
                                        </p>
                                        <p *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: 'dd.MM.yy'}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="eventsSouth && eventsSouth.length > 0" class="column">
                        <div class="subtitle-blue">SÜD</div>
                        <div *ngFor="let city of citiesSouth">
                            <div class="events-in-city">
                                <span>{{city}}</span>
                                <div *ngFor="let event of eventsSouth">
                                    <div *ngIf="event.location.city === city">
                                        <p *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: 'dd.MM.yy'}} - {{ event.endDateTime | date: 'dd.MM.yy'}}
                                        </p>
                                        <p *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: 'dd.MM.yy'}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="eventsWest && eventsWest.length > 0" class="column">
                        <div class="subtitle-blue">WEST</div>
                        <div *ngFor="let city of citiesWest">
                            <div class="events-in-city">
                                <span>{{city}}</span>
                                <div *ngFor="let event of eventsWest">
                                    <div *ngIf="event.location.city === city">
                                        <p *ngIf="eventDuration > 1"> {{ event.beginDateTime | date: 'dd.MM.yy'}} - {{ event.endDateTime | date: 'dd.MM.yy'}}
                                        </p>
                                        <p *ngIf="eventDuration === 1"> {{ event.beginDateTime | date: 'dd.MM.yy'}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </ng-container>
    </div>
</div>
